import React from 'react';
import cx from 'classnames';

import Form from './form';
import Messages from './messages';
import ConversationStarter from './conversation-starter';

import './style.scss';

const Wrapper = React.forwardRef(({ children, className }, ref) => {
  return (
    <div
      ref={ref}
      className={cx('c-chat', {
        [className]: !!className,
      })}
    >
      {children}
    </div>
  );
});

export default { Wrapper, Messages, Form, ConversationStarter };
